<template>
    <v-dialog
        v-model="$props.params.addModelDialog"
        transition="dialog-bottom-transition"
        max-width="600px"
        @keydown.esc="closeAddEditAppDialog()"
        @click:outside="closeAddEditAppDialog()"
    >
        <v-card>
            <v-form @submit.prevent="processAddEditApp()">

                <v-toolbar
                    color="primary"
                    dark
                    :class="dialogHeadingClasses()"
                >
                    <v-icon v-text="icons.mdiPlusCircleOutline" class="mr-3"></v-icon>
                    <div v-text="$gettext('Add a Model')"></div>
                    <v-spacer></v-spacer>
                    <v-icon class="mr-2" @click.native.stop="closeAddEditAppDialog()" v-text="icons.mdiClose"></v-icon>
                    <v-icon @click.native.stop="processAddEditApp()" v-text="icons.mdiContentSave"></v-icon>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-4">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="model"
                                    :label="$gettext('Please choose a model')"
                                    :items="phoneTypes"
                                    item-text="key"
                                    item-value="key"
                                    outlined
                                    :error-messages="modelErrors"
                                    @input="$v.model.$touch()"
                                    @blur="$v.model.$touch()"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeAddEditAppDialog()" v-text="$gettext('Close')"></v-btn>
                    <v-btn color="primary" type="submit" v-text="$gettext('Save')"></v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>

import Vue from 'vue'
import { find, findIndex, size } from 'lodash'

import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import MixinApps from '@/mixins/apps/MixinApps'
import { usePhoneTypesStore } from '@/stores/PhoneTypesStore'
import { mapWritableState } from 'pinia'
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { usePhonesStore } from '@/stores/PhonesStore'

Vue.use(Vuelidate)
const mustHaveAnElement = (value) => value.length > 0

export default {
    components: { Snackbar },
    mixins: [MixinDialog, MixinIcon, MixinStringManipulation, MixinLodashPadStart, MixinApps],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    mounted () {
        let self = this
    },
    data () {
        return {
            model: '',
        }
    },
    methods: {

        processAddEditApp () {

            let self = this

            self.$v.$touch()

            if ( ! self.$v.$invalid) {

                self.$set(self.configurations[self.$props.params.currentSelectedConfigurationIndex].value.phone_model, self.model, [{
                    'appName': 'Settings',
                    'packageId': 'com.android.settings'
                },
                    {
                        'appName': 'Downloads',
                        'packageId': 'com.android.providers.downloads.ui'
                    }])

                self.$parent.$refs.snackbar.showSnackbar(self.$gettext('Model added successfully'))
                self.$emit('modelAddedSuccessfully', self.model)

                self.closeAddEditAppDialog()

            }

        },
        closeAddEditAppDialog () {
            let self = this
            self.$parent.closeDialog('addModelDialog')
        },
        resetForm () {
            let self = this
            self.$v.$reset()
            self.model = ''
            self.strictEnd = self.getDefaultStrictEndValue()
        },
    },
    computed: {
        modelErrors () {
            const errors = []
            if ( ! this.$v.model.$dirty) return errors
            ! this.$v.model.required && errors.push(this.$gettext('Please select a model.'))
            return errors
        },
        ...mapWritableState(usePhoneTypesStore, {
            phoneTypes: 'phoneTypes',
        }),
        ...mapWritableState(usePhonesStore, {
            configurations: 'configurations',
        }),
    },
    validations: {
        model: {
            required,
        }
    }

}
</script>
